import 'chartjs-plugin-labels';

import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Doughnut, Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { makeStyles, Grid } from '@material-ui/core';

import Tab from 'src/components/tab';
import ChartLegend from 'src/components/chartLegend';
import { coloredDatasets } from 'src/helpers/chartJsHelpers';
import ChartWrapper from 'src/components/chartWrapper';

import { setTabExpend } from './slice';

const weekDays = ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const legend = ['Press 2', 'Connected', 'No Press 2', 'Tagged'];

const LineChartData = coloredDatasets('bar', {
  // labels: ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  datasets: [
    {
      label: 'Press 2',
      data: [
        { x: new Date(2018, 11, 24, 0, 0, 0, 0), y: 10 },
        { x: new Date(2018, 11, 25, 0, 0, 0, 0), y: 40 },
        { x: new Date(2018, 11, 26, 0, 0, 0, 0), y: 90 },
        { x: new Date(2018, 11, 27, 0, 0, 0, 0), y: 30 },
        { x: new Date(2018, 11, 28, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 29, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 30, 0, 0, 0, 0), y: 70 },
      ],
      fill: false,
    },
    {
      label: 'Connected',
      data: [
        { x: new Date(2018, 11, 24, 0, 0, 0, 0), y: 10 },
        { x: new Date(2018, 11, 25, 0, 0, 0, 0), y: 40 },
        { x: new Date(2018, 11, 26, 0, 0, 0, 0), y: 90 },
        { x: new Date(2018, 11, 27, 0, 0, 0, 0), y: 30 },
        { x: new Date(2018, 11, 28, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 29, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 30, 0, 0, 0, 0), y: 70 },
      ],
      fill: false,
    },
    {
      label: 'No Press 2',
      data: [
        { x: new Date(2018, 11, 24, 0, 0, 0, 0), y: 10 },
        { x: new Date(2018, 11, 25, 0, 0, 0, 0), y: 40 },
        { x: new Date(2018, 11, 26, 0, 0, 0, 0), y: 90 },
        { x: new Date(2018, 11, 27, 0, 0, 0, 0), y: 30 },
        { x: new Date(2018, 11, 28, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 29, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 30, 0, 0, 0, 0), y: 70 },
      ],
      fill: false,
    },
    {
      label: 'Tagged',
      data: [
        { x: new Date(2018, 11, 24, 0, 0, 0, 0), y: 10 },
        { x: new Date(2018, 11, 25, 0, 0, 0, 0), y: 40 },
        { x: new Date(2018, 11, 26, 0, 0, 0, 0), y: 90 },
        { x: new Date(2018, 11, 27, 0, 0, 0, 0), y: 30 },
        { x: new Date(2018, 11, 28, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 29, 0, 0, 0, 0), y: 50 },
        { x: new Date(2018, 11, 30, 0, 0, 0, 0), y: 70 },
      ],
      fill: false,
    },
  ],
});

const lineChartOptions = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        stacked: false,
        ticks: {
          beginAtZero: true,
          stepSize: 20,
          padding: 20,
          callback: (value, index, values) => {
            return `${value}%`;
          },
        },
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        offset: true,
        type: 'time',
        // distribution: 'series',
        stacked: false,
        bounds: 'ticks',
        time: {
          unit: 'day',
          tooltipFormat: 'DD. MMM',
          displayFormats: {
            day: 'DD. MMM',
          },
        },
        ticks: {
          padding: 20,
          // source: 'labels',
          beginAtZero: true,
          callback: (value, index, values) => {
            return [weekDays[index], value];
          },
        },
        gridLines: {
          display: false,
          // offsetGridLines: false,
        },
        categoryPercentage: 0.5,
        barPercentage: 0.4,
      },
    ],
  },
  legend: {
    display: false,
  },
  tooltips: {
    // callbacks: {
    //   label: (tooltipItem, data) => {
    //     return `${tooltipItem.yLabel}%`;
    //   },
    // },
  },
};

const doughnutChartData = {
  labels: legend,
  datasets: [
    {
      data: [40, 33, 9, 18],
      backgroundColor: ['#325A73', '#F2A629', '#92B6C4', '#BF7A8D'],
    },
  ],
};

const doughnutChartOption = {
  // maintainAspectRatio: false,
  cutoutPercentage: 70,
  rotation: 0.5 * Math.PI,
  elements: {
    arc: {
      borderWidth: 0,
    },
  },
  legend: {
    display: false,
  },
  plugins: {
    labels: {
      render: 'percentage',
      precision: 2,
      position: 'outside',
      fontStyle: 'bold',
      textMargin: 5,
      outsidePadding: 4,
    },
  },
};

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 125,
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
    },
  },
  textWrapper: {
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  doughnutChartWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0),
    },
  },
  text: {
    marginTop: 25,
  },
}));

const LeadResponse = props => {
  const { isTabExpended, timeLine } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title8 {
                html
                text
                raw
              }
              titleTooltip8 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <Tab
      title={prismicData.title8.text}
      tooltipedText={prismicData.titleTooltip8.text}
      drag
      onClick={handelExpand}
      expanded={isTabExpended}
    >
      <Grid container>
        <Grid item xs={12} md={4}>
          <div className={classes.doughnutChartWrapper}>
            <Doughnut data={doughnutChartData} options={doughnutChartOption} height={200} />
          </div>
        </Grid>

        <Grid item xs={12} md={8}>
          <ChartLegend legend={legend} maxWidth={600} />
          <ChartWrapper>
            <Bar options={lineChartOptions} data={LineChartData} height={300} />
          </ChartWrapper>
        </Grid>
      </Grid>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { leadResponse } = overview;
  return { ...leadResponse };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(LeadResponse));
